import RecruitmentsInfinitySelect from './recruitments-infinity-select'

export default RecruitmentsInfinitySelect
